import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDStack } from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';
import PropTypes from 'prop-types';
import { OtherOptions } from 'Views/Authentication/Components/OtherOptions';
import fr from 'facet-rest';
import useHomeContext from 'Context/HomeContext';
import {
  AuthenticationLayout,
  AuthenticationLayoutForm,
  AuthenticationSubmitButton,
  BackToEmailStepButton,
  NavigateToPasswordResetExperimentalButton,
} from '../../Components';

export const AuthLoginPasswordLayout = ({ setAuthCollection }) => {
  const { resource, onSubmit, unsourcedErrors } = useMetaLayoutContext();
  const { homeResource } = useHomeContext();

  return (
    <AuthenticationLayout>
      <AuthenticationLayoutForm
        id={'login-password-form'}
        onSubmit={onSubmit}
        errors={unsourcedErrors}
      >
        <FDStack direction={'column'} spacing={2}>
          <BackToEmailStepButton resource={resource} setAuthCollection={setAuthCollection} />
          <MetaControlField attr={'password'} CustomProps={{ fullWidth: true }} {...dataAttrs('input-password')} />
          <AuthenticationSubmitButton />
          <OtherOptions resource={homeResource} relationships={[fr.relationships.resetPassword.name]} />
          <NavigateToPasswordResetExperimentalButton />
        </FDStack>
      </AuthenticationLayoutForm>
    </AuthenticationLayout>
  );
};

AuthLoginPasswordLayout.propTypes = {
  setAuthCollection: PropTypes.func.isRequired,
};
